module.exports = __webpack_public_path__ + "static/media/profile-pic-1.8b68388f.png";